import React, { Component, useEffect } from 'react';
import Datas from '../data/processFlow/processFlow.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/processFlow";
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie';
import UserService from '../services/UserService';

const ProcessFlow = () => {
    return (
        <Styles>
            <section className="icon-box-area">
                <Container>
                    <Row className='icon-box-heading'>
                        <h3><span>Process</span> Flow</h3>
                    </Row>
                    <Row className='icon-box'>
                        <Col md="12">
                            <div className="full-icon-box">
                                <div className="row icon-box" >
                                    <div className='col box-logo'>
                                        <img src={process.env.PUBLIC_URL + `/assets/images/program cycle.png`} alt="Logo" />
                                    </div>
                                    <div className='col box-text'>
                                        {
                                            Datas.processFlow.map((flowData, i) => (
                                                <div className="flow-item" key={i}>
                                                    <div className="flow-heading">
                                                        <span className='flow-number '>{flowData.id}.</span>
                                                        <span className='flow-title'>{flowData.heading}: </span>
                                                    </div>
                                                    <div className="flow-desc">
                                                        <p>{flowData.description}</p>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default ProcessFlow